import { Check, X } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogTrigger } from "./ui/dialog";
import { FilterResultStockSchema } from "../pages/manual-testing";
import { cn } from "./lib/utils";

export function ResultGrid({ results, isPassed }: { results: FilterResultStockSchema[]; isPassed: boolean }) {
  const sortedResults = [...results].sort((a, b) =>
    a.symbol.localeCompare(b.symbol)
  );

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
      {sortedResults.map((result) => (
        <Dialog key={`${result.symbol}-${result.filter_id}`}>
          <DialogTrigger asChild>
            <div
              className={cn(
                "cursor-pointer border rounded-lg p-3 hover:shadow transition",
                isPassed ? "border-green-300 bg-green-50" : "border-red-300 bg-red-50"
              )}
            >
              <div className="flex items-center gap-2">
                <div
                  className={cn(
                    "w-6 h-6 text-white rounded-full flex items-center justify-center",
                    isPassed ? "bg-green-500" : "bg-red-500"
                  )}
                >
                  {isPassed ? <Check className="w-3 h-3" /> : <X className="w-3 h-3" />}
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-semibold text-gray-900 truncate">{result.symbol}</p>
                  {isPassed && result.filter_name && (
                    <p className="text-xs text-gray-500 truncate">{result.filter_name}</p>
                  )}
                </div>
              </div>
            </div>
          </DialogTrigger>

          <DialogContent className="max-h-[80vh] overflow-y-auto max-w-lg">
            <DialogTitle className="text-base font-medium text-gray-900">
              {result.symbol} Variables
            </DialogTitle>

            {/* ✅ Guard: variables may be undefined on failed crypto stocks */}
            {result.variables && Object.keys(result.variables).length > 0 ? (
              <div className="mt-2 space-y-1 text-sm text-gray-700">
                {Object.entries(result.variables).map(([key, value]) => (
                  <div key={key} className="flex justify-between gap-4 py-0.5 border-b border-gray-100">
                    <span className="font-medium text-gray-600 text-xs">{key}</span>
                    <span className={cn(
                      "font-mono text-xs font-semibold",
                      value > 0 ? "text-green-600" : value < 0 ? "text-red-600" : "text-gray-500"
                    )}>
                      {value.toFixed(6)}
                    </span>
                  </div>
                ))}
              </div>
            ) : (
              <p className="text-sm text-gray-400 mt-2 italic">No variable data available.</p>
            )}
          </DialogContent>
        </Dialog>
      ))}
    </div>
  );
}